module.exports = __webpack_public_path__ + "img/jian_chuan.8ad20392.png";